import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

const ModalSuccessPayment = ({ open, setOpen }) => {
  const navigate = useNavigate();
  const handleClose = () => {
    navigate("/dashboard/account");
    setOpen(false);
  };
  return (
    <Dialog open={open}>
      <DialogContent sx={{ padding: 5 }}>
        <DialogTitle sx={{ textAlign: "center" }} variant="h5">
          💳 Redirección para realizar el pago
        </DialogTitle>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 4,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 2,
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          ></Box>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography sx={{ textAlign: "center" }}>
              🔁 Una vez finalizado, vuelve a esta página. Si tu pago no se
              refleja automáticamente después de unos segundos, recarga la
              página.
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={handleClose}
          sx={{ borderColor: "white", color: "white" }}
        >
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalSuccessPayment;
